// extracted by mini-css-extract-plugin
export default {"task_row":"TaskEntry_task_row__R9Ue-","task_link":"TaskEntry_task_link__WKpb9"};